import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import CmsPage from 'components/cms-page'
import * as R from 'ramda'
import Head from 'next/head'

import { fullName } from 'utilities/user'
import { CONTENTFUL_SURVEY_ID } from './constants'
import { getCoach } from './queries.graphql'
import { AnalyticsPage } from 'containers/analytics'

const GET_STARTED_SECTION_EXPERIMENT = {
  fields: {
    component: 'GetStartedExperiment',
  },
}

const STICKY_CTA_SECTION_EXPERIMENT = {
  fields: {
    component: 'StickyCTAExperiment',
  },
}

const CHAT_BUTTON_EXPERIMENT = {
  fields: {
    component: 'ChatButtonExperiment',
  },
}

const COMPONENTS_FOLLOWED_BY_FOOTER_EXPERIMENT = new Set(['FooterExperiment'])

const CoachProfile = ({
  username,
  coachProfilePageEntry,
  surveyEntry,
  query = {},
}) => {
  const coachPayload = useQuery(getCoach, {
    variables: { username },
  })

  const coach = R.path(['data', 'coachByUsername'], coachPayload)

  const analyticsProperties = useMemo(() => {
    return {
      coachId: coach?.id,
    }
  }, [coach?.id])

  if (!coach || !coachProfilePageEntry || !surveyEntry) {
    return null
  }

  const { fields } = coachProfilePageEntry

  const getSections = () => {
    return R.reduce(
      (allSections, section) => {
        const component = section.fields.component

        if (component !== 'SignUp') {
          allSections.push(section)
        }

        if (COMPONENTS_FOLLOWED_BY_FOOTER_EXPERIMENT.has(component)) {
          allSections.push(STICKY_CTA_SECTION_EXPERIMENT)
          allSections.push(CHAT_BUTTON_EXPERIMENT)
        }

        return allSections
      },
      [],
      fields.sections
    )
  }

  const sections = getSections()

  const coachName = fullName(coach.user)
  const description = `Stay on top of your fitness goals with online personal trainer ${coachName}.`

  // Required to be a variable to avoid rendering <!-- --> in the title
  const title = `${coachName} | Personal Trainer at Kickoff`

  return (
    <AnalyticsPage name="CLP" properties={analyticsProperties}>
      <Head>
        <meta name="description" content={description} />
        <title key="title">{title}</title>
      </Head>
      <CmsPage
        survey={surveyEntry}
        surveyId={CONTENTFUL_SURVEY_ID}
        query={query}
        fields={{
          ...fields,
          sections,
        }}
        coach={coach}
        isCoachPage={true}
      />
    </AnalyticsPage>
  )
}

export default CoachProfile
